import { render, staticRenderFns } from "./CustomerServiceFab.vue?vue&type=template&id=63dd1398&scoped=true"
import script from "./CustomerServiceFab.vue?vue&type=script&lang=js"
export * from "./CustomerServiceFab.vue?vue&type=script&lang=js"
import style0 from "./CustomerServiceFab.vue?vue&type=style&index=0&id=63dd1398&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dd1398",
  null
  
)

export default component.exports